import { memo } from "react";
import { ModuleItem } from "./index";

function CourseSidebar({ modules, activeModuleId, onSelect }) {
  return (
    <div className="max-sm:w-[300px] sm:w-[350px] md:w-full bg-white h-full overflow-y-scroll rounded-2xl border p-4">
      <h3 className="text-lg font-semibold mb-4">Course Content</h3>
      <div className="flex-1 overflow-y-auto space-y-2">
        {modules.map((module, index) => (
          <ModuleItem
            key={module.id}
            module={module}
            index={index}
            active={module.id === activeModuleId}
            onClick={() => onSelect(module.id)}
          />
        ))}
      </div>
    </div>
  );
}
export default memo(CourseSidebar);
